/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import SocialSelection from 'app/components/SocialModal/SocialSelection.jsx';
import NewScheduleControl from 'app/components/Queue/NewScheduleControl.jsx';
import DropdownList from 'react-widgets/DropdownList';
import CategoryItem from 'app/components/DropDownItems/CategoryItem.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';
import ViewOptions from 'app/components/Queue/ViewOptions.jsx';


class QueueTabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bannerTop: null,
            fixedToolbar: false,
            socials: this.props.socials,
            showNewScheduleTool: false,
            currentBreakpoint: 'desktop'
        };

        this.onScroll = this.onScroll.bind(this);
        this.showNewScheduleTool = this.showNewScheduleTool.bind(this);
        this.toggleSocialSelector = this.toggleSocialSelector.bind(this);
        this.filterCallback = this.filterCallback.bind(this);
        this.searchCallback = this.searchCallback.bind(this);
        this.navigateToQueue = this.navigateToQueue.bind(this);
        this.onCategoryUpgrade = this.onCategoryUpgrade.bind(this);
        this.interactionCheck = this.interactionCheck.bind(this);
        this.socialSelectorRef = React.createRef();

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            socials = [];

        socials = (props.socials.filteredList.length) ? props.socials.filteredList : props.socials.list;

        if (!_.isEqual(state.socials, socials)) {
            nextState.socials = socials;
            if (state.showNewScheduleTool) {
                nextState.showNewScheduleTool = false;
            }
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {

        //window.addEventListener("scroll", this.onScroll);
        document.addEventListener('mouseup', this.interactionCheck);
        document.addEventListener('touchend', this.interactionCheck);

    }

    componentWillUnmount() {

        //window.removeEventListener("scroll", this.onScroll);
        document.removeEventListener('mouseup', this.interactionCheck);
        document.removeEventListener('touchend', this.interactionCheck);

    }

    onScroll() {
        let bannerTop = this.state.bannerTop,
            fixedToolbar = this.state.fixedToolbar;

        // if (bannerTop === null) {
        //     if (this.props.contentref !== undefined && this.props.contentref.current !== undefined) {
        //         bannerTop = this.props.contentref.current.offsetTop;
        //         this.setState({
        //             bannerTop: bannerTop
        //         });
        //     }
        // } else {
        //     if (bannerTop < window.scrollY && fixedToolbar === false) {
        //         this.setState({
        //             fixedToolbar: true
        //         });
        //     } else if (bannerTop > window.scrollY && fixedToolbar === true) {
        //         this.setState({
        //             fixedToolbar: false
        //         });
        //     }
        // }

    }

    interactionCheck(e) {

        if ((this.socialSelectorRef.current && this.socialSelectorRef.current.contains(e.target)) ||
            (this.props.queueSelectorRef.current && this.props.queueSelectorRef.current.contains(e.target))) {
            return;
        } else if (this.socialSelectorRef.current && this.props.showSocialSelector) {
            this.props.toggleSocialSelector(false);
        }

    }

    showNewScheduleTool(e) {
        let nextState = (this.state.showNewScheduleTool) ? false : true;

        this.setState({
            showNewScheduleTool: nextState
        });

    }

    toggleSocialSelector() {

        let visible = (this.props.showSocialSelector) ? false : true;

        if (visible == false) {
            this.props.clearFilter('socials');
        }

        this.props.toggleSocialSelector(visible);

    }

    filterCallback(e, key) {

		if (key === '') {
			this.props.clearFilter('socials');
		} else {
			this.props.filterStore('socials', ['psID'], key, true);
		}

	}

    searchCallback(e, search) {

		if (this.state.serviceId) {
			this.props.filterStore('socials', ['psID'], this.props.social.psId.toString(), true);
			this.props.filterStore('socials', ['name'], search, false, true);
		} else {
			this.props.filterStore('socials', ['name'], search);
		}

    }

    navigateToQueue(e) {

        let path = '/queue/detail/',
            pathRegex = /(\/\w+\/\w+\/)/,
            matches = null;

        if ((matches = this.props.router.location.pathname.match(pathRegex)) !== null) {
            path = matches[0];
        }

        if (e.currentTarget.dataset.id) {
            this.props.router.navigate(path + e.currentTarget.dataset.id);
            this.toggleSocialSelector(false);
            this.props.clearFilter('socials');
        }

    }

    onCategoryUpgrade(e) {

        this.props.showUpgradeModal(this.props.closeAllModals, 'category');

    }

    render() {

        let routeParams = this.props.router.params ? this.props.router.params : {},
            socialId = routeParams.socialId ? routeParams.socialId : 0,
            Title = null,
            controlBarClass = `editor-control-bar ${this.props.source}`,
            socialSelector = null,
            controlStateIcon = 'icon ion-arrow-right-b',
            socialSelectorClass = 'control-button social-selector',
            spacer = null,
            deleteSelectedButton = null,
            cancelDelete = null,
            trashClass = "icon ion-ios-trash-outline",
            deleteControls = null,
            everqueueConfig = null,
            everqueueState = '',
            everqueueStateLabel = null,
            everqueueToggle = null,
            newScheduleToggle = null,
            newScheduleControl = null,
            controlBar = null,
            categoryList = this.props.categoryList,
            constants = this.props.app.config.constants,
            categoryFilter = null,
            viewToggle = null;

        categoryFilter = (
            <DropdownList
                data={categoryList}
                dataKey='id'
                textField='label'
                filter={false}
                renderListItem={({ item }) => {
                    return (
                        <CategoryItem
                            item={item}/>
                    );
                }}
                renderValue={({ item }) => {
                    return (
                        <CategoryItem
                            item={item}/>
                    );
                }}
                placeholder="All Categories"
                aria-label="Filter by category"
                containerClassName="category-drop"
                value={this.props.category}
                onChange={this.props.onCategoryFilter}/>
        );
        if (_.isEmpty(this.props.social) || this.props.social.id === 0) {
            return null;
        }

        // If the user doesn't have permissions for categories, only show the category filter if they've had
        // category access in the past and have created some
        if (this.props.user.perms.resources && !this.props.user.perms.resources.categories) {
            if (categoryList.length <= 1) {
                categoryFilter = null;
            }
        }

        if (this.props.social.hasOwnProperty('link')) {
            Title = <a href={this.props.social.link} title={this.props.social.name} alt={this.props.social.name} target="_blank">
                <span>{this.props.social.name}</span>
            </a>;
        } else {
            Title = <span>{this.props.social.name}</span>;
        }

        if (this.state.fixedToolbar) {
            controlBarClass += " fixed";
            spacer = <div className="fixed-spacer"></div>;
        }

        if (this.state.showNewScheduleTool) {
            controlBarClass += " new-schedule";
        }

        if (this.props.showSocialSelector) {
            controlStateIcon = 'icon ion-arrow-down-b';
            socialSelectorClass += ' open';
            socialSelector = (
                <div className="queue-social-selector" ref={this.socialSelectorRef}>
                    <SocialSelection
                        {...this.props}
                        displayHeader={true}
                        context="queue"
                        filterHandler={this.filterCallback}
                        searchHandler={this.searchCallback}
                        socialClickHandler={this.navigateToQueue} />
                </div>
            );
        }

        if (this.props.router.location.pathname.match("queue/everqueue") || this.props.router.location.pathname.match("queue/detail")) {
            if (this.props.selectedForDelete > 0) {
                let label = (this.props.selectedForDelete === 1) ? "item" : "items";
                deleteSelectedButton = (
                    <div className="btn-flat delete-selected" onClick={this.props.finalizeDelete} role="button" aria-label={`Delete ${this.props.selectedForDelete} ${label}`}>
                        Delete {this.props.selectedForDelete} {label}
                    </div>
                );
                trashClass = "icon ion-ios-trash";
                cancelDelete = (
                    <a href="#" style={{"marginRight": "10px"}} onClick={this.props.cancelDelete}>Cancel</a>
                );
            }
            deleteControls = (
                <div className="control-button">
                    <div className="control-icon">
                        <i className={trashClass}/>
                    </div>
                    <div className="control-state">
                        {deleteSelectedButton}
                        {cancelDelete}
                        <a href="#" onClick={this.props.deleteAll}>Delete all</a>
                    </div>
                </div>
            );

        } else if (this.props.router.location.pathname.match("schedule")) {

            if (this.state.showNewScheduleTool) {
                categoryFilter = null;
                newScheduleToggle = (
                    <div className="new-schedule-toggle" onClick={this.showNewScheduleTool} role="button" aria-label="cancel">
                        <i className="icon ion-ios-minus-outline"></i> Nevermind
                    </div>
                );
                newScheduleControl = (
                    <NewScheduleControl
                        {...this.props}
                        categoryList={categoryList}
                        onCategoryUpgrade={this.onCategoryUpgrade}
                        cancelHandler={this.showNewScheduleTool} />
                );
            } else {
                newScheduleToggle = (
                    <div className="new-schedule-toggle" onClick={this.showNewScheduleTool} role="button" aria-label="add new time">
                        <i className="icon ion-ios-plus-outline"></i> Add New Time
                    </div>
                );
            }

        }

        // control-bar-wrapper is set to display-table for everqueue controls, when these aren't present
        // set the elements anyway so the main 'cell' (the social selector) doesn't stretch to 100%
        everqueueConfig = (
            <div className="tab-right queue-new tab-button no-margin everqueue-tab-button"></div>
        );

        if (this.props.router.location.pathname.match('everqueue')) {
            if (parseInt(this.props.social.poolActive, 10)) {
                everqueueStateLabel = 'EverQueue On';
                everqueueState = 'on';
            } else {
                everqueueStateLabel = 'EverQueue Off';
                everqueueState = 'off';
            }
            everqueueToggle = (
                <div className={"tab-right queue-new tab-button everqueue-tab-button-toggle " + everqueueState} onClick={this.props.toggleEverqueue} role="button" aria-label="Toggle Everqueue">
                     <span className="everqueue-toggle-label">{everqueueStateLabel}</span>
                </div>
            );
            if (this.props.router.location.pathname.match('settings')) {
                categoryFilter = null;
                everqueueConfig = (
                    <div className="tab-right queue-new tab-button no-margin everqueue-tab-button">
                        <Link to={'/queue/everqueue/' + this.props.socialId} alt="EverQueue List" title="EverQueue List">
                            <div className="control-icon">
                                <i className="icon ion-navicon-round"/>
                            </div>
                            EverQueue List
                        </Link>
                    </div>
                );
            } else {
                everqueueConfig = (
                    <div className="tab-right queue-new tab-button no-margin everqueue-tab-button" >
                        <Link to={'/queue/everqueue/' + this.props.socialId + '/settings'} alt="EverQueue Settings" title="EverQueue Settings">
                            <div className="control-icon">
                                <i className="icon ion-gear-b"/>
                            </div>
                            Settings
                        </Link>
                    </div>
                );
            }
        }

        let editorSubControls = null;
        if (this.props.router.location.pathname.match("queue/detail") ||
            this.props.router.location.pathname.match("queue/calendar")) {
            viewToggle = <ViewOptions {...this.props}/>
        }

        if (this.props.router.location.pathname.match("queue/detail") ||
            this.props.router.location.pathname.match("queue/schedule") ||
            this.props.router.location.pathname.match("queue/everqueue")) {
            editorSubControls = (
                <div className="editor-sub-controls">
                    <div className="control-bar-wrapper split">
                        <div className="split-cell left">
                            {categoryFilter}
                        </div>
                        <div className="split-cell right">
                            {newScheduleToggle}
                            {deleteControls}
                        </div>
                    </div>
                    {newScheduleControl}
                </div>
            );
        }



        return (
            <div>
                <Breakpoint desktop only>
                    {spacer}
                    <div className={controlBarClass}>
                        <div className="editor-main-controls clearfix">
                            <div className="control-bar-wrapper split">
                                {viewToggle}
                                {socialSelector}
                                {everqueueConfig}
                                {everqueueToggle}
                            </div>
                        </div>
                        {editorSubControls}
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className={controlBarClass + " mobile"}>
                        <div className="editor-main-controls clearfix">
                            <div className="control-bar-wrapper">
                                <div className={socialSelectorClass} onClick={this.toggleSocialSelector} role="button" aria-label="show social selector">
                                    <div className="social-id">
                                        <div className="control-button-avatar">
                                            <SocialAvatar social={this.props.social} compact={true} compactSmall={true} showCompactName={false}/>
                                        </div>
                                        <div className="control-button-label">
                                            {Title}
                                        </div>
                                    </div>
                                    <div className="control-state">
                                        <i className={controlStateIcon}></i>
                                    </div>
                                </div>
                                {socialSelector}
                                <div className="view-toggle">
                                    {viewToggle}
                                </div>
                            </div>
                        </div>
                        {(this.props.router.location.pathname.match('everqueue')) ? (
                            <div className="editor-sub-controls">
                                {everqueueToggle}
                                {everqueueConfig}
                            </div>
                        ) : null}
                        {(newScheduleControl === null) ? (
                            <div className="editor-sub-controls">
                                {categoryFilter}
                                {(this.props.selectedForDelete > 0) ? null : deleteControls}
                            </div>
                        ) : null}
                        {(this.props.selectedForDelete > 0) ? (
                            <div className="editor-sub-controls mobile-delete">
                                {deleteControls}
                            </div>
                        ) : null}
                        {(newScheduleToggle !== null && newScheduleControl === null) ? (
                            <div className="editor-sub-controls">
                                {newScheduleToggle}
                            </div>
                        ) : null}
                        {newScheduleControl}
                    </div>
                </Breakpoint>
            </div>
        );

    }

};

QueueTabs.displayName = "QueueTabs";

QueueTabs.propTypes = {
    postModalMethod: PropTypes.func,
    social: PropTypes.object,
    selectedForDelete: PropTypes.number,
    category: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number
    ]),
    categoryList: PropTypes.array,
    source: PropTypes.string
};

QueueTabs.defaultProps = {
    postModalMethod: null,
    social: {},
    selectedForDelete: 0,
    category: null,
    categoryList: [],
    source: "queue"
};

export default QueueTabs;
